import { Injectable, inject } from '@angular/core';
import {
  DocumentTypeDto,
  DocumentTypesClient,
} from '@r1-development/fileshed-angular-client';
import { FileDocumentTypeUi } from '../../../../../shared/models/files.model';
import { GlobalState } from './global.state';
import { FileDocumentTypes } from '../../../../../shared/models/file-document-types.model';

@Injectable({
  providedIn: 'root',
})
export class FileDocumentTypesEffect {
  private readonly globalState = inject(GlobalState);
  private readonly documentTypesClient = inject(DocumentTypesClient);

  loadFileDocumentTypesToState(): void {
    this.documentTypesClient
      .getDocumentTypes()
      .subscribe((data: DocumentTypeDto[]) => {
        const fileDocumentTypesUi = data.map(
          (documentTypeDto: DocumentTypeDto) =>
            this.convertDocumentType(documentTypeDto)
        );
        this.globalState.setFileDocumentTypes(fileDocumentTypesUi);
      });
  }

  private convertDocumentType(
    documentTypeDto: DocumentTypeDto
  ): FileDocumentTypeUi {
    return {
      id: documentTypeDto.id!,
      documentType: documentTypeDto.documentType as FileDocumentTypes,
    };
  }
}
